import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { LoginComponent } from 'src/app/shared/components/login/login.component';
import { CouponModalComponent } from 'src/app/shared/components/coupon-modal/coupon-modal.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OfferService } from 'src/app/offers/services/offer/offer.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { CommonService } from '../../services/common/common.service';
import { Merchant, Offer } from '../../interfaces/offers.interface';

export interface OfferCard extends Offer {
  merchant: Merchant;
  isDisabled: boolean;
}

@Component({
  selector: 'app-offers-card',
  templateUrl: './offers-card.component.html',
  styleUrls: ['./offers-card.component.scss']
})
export class OffersCardComponent implements OnInit {

  @Input() offer: OfferCard;
  @Input() authenticated_user: boolean;
  @Input() isMobile: boolean;
  @Input() clickPosition: any;
  @Input() offerType: any;
  @Input() siteSection: any;

  @Output() merchantClicked = new EventEmitter<any>();
  modalRef: BsModalRef;
  public detailsUrlPath: string = '';

  constructor(
    private modalService: BsModalService,
    private offerService: OfferService,
    private router: Router,
    public _authService: AuthService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.detailsUrlPath = `/offers/details/${this.offer.merchant?.id}/all/${this.offer.merchant.attributes?.name?.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase()}`
  }

  checkKeyExists(json, key) {
    return key in json ? true : false;
  }

  emitRedeemOffer(merchant, event) {
    event.stopPropagation();
    if (this._authService.isAuthenticated()) {
      this.claimOffer(merchant);
    } else {
      this.openLogin(merchant);
    }
  }
  claimOffer(offer: OfferCard) {
    this.analyticsOfferData(offer, 'claim offer');

    let selectedOffer = {
      'merchant_id': offer.merchant.id,
      'merchant_name': offer.merchant.attributes.name,
      'merchant_logo': offer.merchant.attributes.logo_url,
      'merchant_website': offer.merchant.attributes.website,
      'offer_title': offer.attributes.title,
      'offer_type': offer?.attributes.offer_type,
      'end_date': offer.attributes.end_date,
      'id': offer.id,
      'redemption_url': offer.attributes?.redemption_url
    };

    this.openCoupon(selectedOffer, offer)

  }
  openCoupon(selectedOffer, offer: OfferCard) {
    const initialState = {
      selectedOffer: selectedOffer,
    }
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'coupon-modal'
    };
    this.modalRef = this.modalService.show(CouponModalComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.redeemStatus.subscribe(res => {
      offer.attributes.claimable = false;

    })
    this.modalRef.content.hideEvent.subscribe(res => {
      this.modalRef.hide();
    })
  }

  openLogin(merchant) {
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'login-modal'
    };
    this.modalRef = this.modalService.show(LoginComponent, Object.assign({}, config, {}));
    this.modalRef.content.loginStatus.subscribe(res => {
      if (res) {
        this.claimOffer(merchant);
      }
    })
    this.modalRef.content.closeModal.subscribe(res => {
      this.modalRef.hide();
    })
  }
  clickMerchant(event, offer: OfferCard, action) {    
    this.analyticsOfferData(offer, action);
    event.stopPropagation()
    this.router.navigate([this.detailsUrlPath]);
  }

  private analyticsOfferData(offer: OfferCard, btnName:string) {   
    const offerRedirectPath =  window.location.origin + this.detailsUrlPath ;
    const payload = {
      siteSection: 'offer_tiles_homepage', 
      merchantName: offer.merchant.attributes.name,
      clickPosition: this.clickPosition,
      merchantID: offer.merchant?.id,
      offerID: offer?.id,
      offerName: offer?.attributes?.title, 
      pageURL: offerRedirectPath,
      button_name: `${offer.merchant.attributes?.name}|${btnName}`,
      linkType : "interaction",
      category: this.offerType ?? "productivity"
    }
    
    this.commonService.sendAnalyticsData('offer_click', 'offer' , payload)
  }
}
